import { PURGE } from "redux-persist";
import { actions } from "../util/actions";

const INITIAL_STATE = {
  modules: [],
  chapters: [],
  selected_module: [],
  modules_count: null,
  user_ilearn: {},
  loaded: false,
};

const nullify = (item) => {
  return item === undefined ? null : item;
};

export const iLearnReducer = (
  state = INITIAL_STATE,
  // state = MOCK_STATE,
  action
) => {
  switch (action.type) {
    case PURGE: {
      return INITIAL_STATE;
    }

    case actions.STORE_MODULE_INFO: {
        const {getILEARNModules, chapters} = action
        console.log(action)
        return {
            ...state,
            modules: getILEARNModules.ilearn_modules,
            chapters: chapters,
            modules_count: getILEARNModules?.ilearn_modules?.length,
            loaded: true,
        }
    }

    case actions.STORE_ILEARN_USER_INFO: {
        const {getILEARNUser} = action
        return {
            ...state,
            user_ilearn: getILEARNUser.user_ilearn,
        }
    }

    case actions.UPDATE_USER_ILEARN_PROGRESS: {
      const {chapters} = action;
      return {
        ...state,
        chapters: chapters,
      }
    }
    default: {
        return state;
      }
  }
};
